import { render, staticRenderFns } from "./Numeric.vue?vue&type=template&id=507bb3a7&scoped=true&"
import script from "./Numeric.vue?vue&type=script&lang=js&"
export * from "./Numeric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507bb3a7",
  null
  
)

export default component.exports